import { CheckCircleFilled } from "@ant-design/icons";
import { useAddInfluencerPrimaryContact } from "@entities/brief/lib/hooks/useAddInfluencerPrimaryContact";
import {
  IBriefInfluencerV2,
  IInfluencerContact,
} from "@shared/lib/types/briefInfluencerV2";
import { Flex, Rate, Row, Spin } from "antd";
import classNames from "classnames";
import { useEffect, useState } from "react";
import styles from "./styles.module.scss";

import { useGetBriefInfluencerV2 } from "@entities/brief/lib/hooks/useGetBriefInfluencerV2";
import { InfDetailsButtonV2 } from "@features/InfDetailsButtonV2";
import { useBriefStore } from "@pages/layout/BriefLayout/lib/useLayoutStore";
import { Button } from "@shared/ui/Button";

interface SelectContactProps {
  briefInfluencerId: string;
  creatorInfo: {
    name: string;
    dp: string;
    rating: number;
  };
  onClose: () => void;
  onSuccess: (briefInfluencer: IBriefInfluencerV2) => void;
  initialContact: IInfluencerContact | null;
}

export function SelectContact({
  briefInfluencerId,
  creatorInfo,
  onClose,
  onSuccess,
  initialContact,
}: SelectContactProps) {
  const [selectedContact, setSelectedContact] =
    useState<IInfluencerContact | null>(null);
  const { briefId } = useBriefStore();

  const { addInfluencerPrimaryContact, isAdding, isAdded } =
    useAddInfluencerPrimaryContact(briefId, onSuccess);

  const { briefInfluencer, refetch, isFetching } =
    useGetBriefInfluencerV2(briefInfluencerId);

  const contacts = briefInfluencer?.influencer?.contacts;

  useEffect(() => {
    if (contacts) {
      if (initialContact) {
        return setSelectedContact(
          contacts.find(
            (c) => c.influencerContactId === initialContact.influencerContactId
          ) ?? null
        );
      } else {
        setSelectedContact(contacts.find((c) => c.isPrimaryContact) ?? null);
      }
    }
  }, [contacts]);

  useEffect(() => {
    if (isAdded) {
      onClose();
    }
  }, [isAdded]);

  if (isFetching) {
    return (
      <Row justify="center" style={{ marginTop: 100 }}>
        <Spin />
      </Row>
    );
  }

  if (!contacts || contacts.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#bfbfbf",
          fontSize: 18,
          fontWeight: 500,
        }}
      >
        No Contacts Found
      </div>
    );
  }

  return (
    <div>
      <div className={styles.creatorCard}>
        <img
          src={creatorInfo.dp}
          alt={creatorInfo.name}
          className={styles.creatorAvatar}
        />
        <div>
          <div className={styles.creatorName}>{creatorInfo.name}</div>
          <div>
            <Rate disabled value={creatorInfo.rating} />
          </div>
        </div>
        <InfDetailsButtonV2
          creatorInfo={creatorInfo}
          socialMediaInfluencerReq={{
            influencerId: briefInfluencer?.influencer?._id,
          }}
          handleSuccess={refetch}
        />
      </div>
      <div className={styles.infoText}>
        All the campaigns related communication including payments will be done
        through this phone no. and email id, if you want to change the primary
        contact, change it in influencer's tab.
      </div>
      {/* Contacts List */}
      <div className={styles.contactsCard}>
        <div className={styles.contactsHeader}>Contacts</div>
        <Flex vertical gap={16}>
          {contacts.map((contact, idx) => (
            <Flex
              vertical
              className={styles.contactRowContainer}
              gap={8}
              onClick={() => {
                setSelectedContact(contact);
                // if (contact?.emailId) {
                //   setSelectedContact(contact);
                // } else {
                //   message.error("Contact email is required");
                // }
              }}
            >
              <div
                key={contact.influencerContactId}
                className={classNames(styles.contactRow)}
              >
                <div className={styles.contactCheck}>
                  {selectedContact?.influencerContactId ===
                  contact.influencerContactId ? (
                    <CheckCircleFilled
                      style={{ color: "#52c41a", fontSize: 22 }}
                    />
                  ) : (
                    <span
                      style={{
                        display: "inline-block",
                        width: 22,
                        height: 22,
                        borderRadius: "50%",
                        border: "2px solid #d9d9d9",
                      }}
                    />
                  )}
                </div>
                <div className={styles.contactInfo}>
                  <div className={styles.contactName}>
                    {contact?.agencyUserId
                      ? contact?.agencyUser?.name
                      : contact.name}
                  </div>
                  <div className={styles.contactType}>{contact.type}</div>
                </div>
                <div className={styles.contactPhone}>
                  {contact?.agencyUserId
                    ? `${contact?.agencyUser?.countryCode} ${contact?.agencyUser?.phoneNumber}`
                    : `${contact?.countryCode} ${contact?.phoneNumber}`}
                </div>
                <div>
                  <div className={styles.contactEmail}>
                    {contact?.agencyUserId
                      ? contact?.agencyUser?.emailId
                      : contact?.emailId}
                  </div>
                  <div className={styles.contactTags}>
                    {contact.isPrimaryContact && (
                      <span className={styles.primaryTag}>Primary</span>
                    )}
                    {contact.agency && (
                      <span className={styles.agencyTag}>
                        Agency: {contact.agency.name}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              {/* {selectedContact?.influencerContactId ===
                contact.influencerContactId && (
                <ContactVerificationStatusCard
                  contact={{
                    ...selectedContact,
                  }}
                  handleSuccess={refetch}
                  influencerId={briefInfluencer?.influencer?._id}
                />
              )} */}
            </Flex>
          ))}
        </Flex>
      </div>
      <Flex justify="end" gap={16} style={{ marginTop: 16 }}>
        <Button
          type="primary"
          disabled={
            !selectedContact
            // ||
            // selectedContact.status !== CONTACT_STATUS.Verified
          }
          loading={isAdding}
          onClick={() =>
            addInfluencerPrimaryContact({
              briefInfluencerId,
              contact: selectedContact!,
            })
          }
        >
          Verify Contact
        </Button>
      </Flex>
    </div>
  );
}
